(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_form-input-upload"] && !Shopify.designMode) return;
  try {
    (() => {
    const endpoint = 'https://uploads.midwesternlaserart.com/api/upload';

    const initializeWidget = (widget) => {
      if (!widget || widget.dataset.mwlaReady === 'true') return;

      const input = widget.querySelector('[data-mwla-upload-input]');
      const hidden = widget.querySelector('[data-mwla-upload-value]');
      const status = widget.querySelector('[data-mwla-upload-status]');
      const form = widget.closest('form');

      if (!input || !hidden || !status) return;
      widget.dataset.mwlaReady = 'true';

      if (!form) {
        status.dataset.state = 'error';
        status.textContent = 'This upload block must be placed inside a form.';
        input.disabled = true;
        return;
      }

      const maximumFiles = Math.min(5, Math.max(1, Number(widget.dataset.maxFiles) || 5));
      const required = widget.dataset.required === 'true';
      const submitButtons = form.querySelectorAll('[type="submit"]');

      const setBusy = (busy) => {
        form._mwlaBusyWidgets = form._mwlaBusyWidgets || new Set();
        if (busy) {
          form._mwlaBusyWidgets.add(widget);
        } else {
          form._mwlaBusyWidgets.delete(widget);
        }

        const formIsBusy = form._mwlaBusyWidgets.size > 0;
        input.disabled = busy;

        submitButtons.forEach((button) => {
          if (formIsBusy) {
            if (!button.hasAttribute('data-mwla-originally-disabled')) {
              button.dataset.mwlaOriginallyDisabled = button.disabled ? 'true' : 'false';
            }
            button.disabled = true;
          } else {
            button.disabled = button.dataset.mwlaOriginallyDisabled === 'true';
            delete button.dataset.mwlaOriginallyDisabled;
          }
        });
      };

      const showError = (message) => {
        hidden.value = '';
        input.value = '';
        status.dataset.state = 'error';
        status.textContent = message;
      };

      input.addEventListener('change', () => {
        hidden.value = '';
        status.dataset.state = '';

        if (!input.files.length) {
          status.textContent = '';
          return;
        }

        if (input.files.length > maximumFiles) {
          showError(`Please choose no more than ${maximumFiles} file${maximumFiles === 1 ? '' : 's'}.`);
          return;
        }

        const totalBytes = [...input.files].reduce((sum, file) => sum + file.size, 0);
        if (totalBytes > 50 * 1024 * 1024) {
          showError('The combined upload must be 50 MB or smaller.');
          return;
        }

        const payload = new FormData();
        [...input.files].forEach((file) => payload.append('files', file));

        const xhr = new XMLHttpRequest();
        xhr.open('POST', endpoint);
        xhr.timeout = 120000;
        setBusy(true);
        status.textContent = 'Uploading artwork… 0%';

        xhr.upload.addEventListener('progress', (event) => {
          if (event.lengthComputable) {
            const percentage = Math.round((event.loaded / event.total) * 100);
            status.textContent = `Uploading artwork… ${percentage}%`;
          }
        });

        xhr.addEventListener('load', () => {
          setBusy(false);
          let result = {};
          try {
            result = JSON.parse(xhr.responseText);
          } catch (_error) {
            result = {};
          }

          if (xhr.status >= 200 && xhr.status < 300 && result.form_value) {
            hidden.value = result.form_value;
            status.dataset.state = 'success';
            status.textContent = `${result.files.length} file${result.files.length === 1 ? '' : 's'} uploaded successfully.`;
          } else {
            showError(result.error || 'Artwork upload failed. Please try again.');
          }
        });

        xhr.addEventListener('error', () => {
          setBusy(false);
          showError('Artwork upload failed. Please check your connection.');
        });

        xhr.addEventListener('timeout', () => {
          setBusy(false);
          showError('Artwork upload timed out. Please try again.');
        });

        xhr.send(payload);
      });

      form.addEventListener('submit', (event) => {
        if (form._mwlaBusyWidgets && form._mwlaBusyWidgets.size > 0) {
          event.preventDefault();
          status.dataset.state = 'error';
          status.textContent = 'Please wait for the artwork to finish uploading.';
          return;
        }

        if (required && !hidden.value) {
          event.preventDefault();
          status.dataset.state = 'error';
          status.textContent = 'Please upload the required artwork before submitting.';
          input.focus();
        }
      });
    };

    const initializeAll = (root = document) => {
      if (root.matches && root.matches('[data-mwla-upload]')) initializeWidget(root);
      root.querySelectorAll?.('[data-mwla-upload]').forEach(initializeWidget);
    };

    initializeAll();

    if (!window._mwlaUploadEditorEventsBound) {
      window._mwlaUploadEditorEventsBound = true;
      document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
      document.addEventListener('shopify:block:select', (event) => initializeAll(event.target));
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
